import React, { useEffect, useState } from 'react'
import { useStore, Storage } from '../lib'
import { Link, NavLink, useHistory } from 'react-router-dom'
import logoUhul from '../assets/base/logo_uhul2.jpg'
import { BlankWindow, Certificate } from '../views'

type Props = {
  isCompact?: boolean
  isActionsShown?: boolean
  isTimeShown?: boolean
  startTime?: number
  endTime?: number
  customScore?: number
  customErrors?: number
  customText?: string[]
  statusText?: string[]
}
export const SideNav: React.FC<Props> = ({
  isCompact,
  isActionsShown,
  isTimeShown,
  startTime,
  endTime,
  customScore,
  customErrors,
  customText,
  statusText,
}) => {
  const [username, setUsername] = useState<string>('')
  const [score, setScore] = useState<number>(0)
  const [errors, setErrors] = useState<number>(0)
  const [timeSec, setTimeSec] = useState<number>(0)
  const [successRate, setSuccessRate] = useState<number>(0)
  const [intervalHandler, setIntervalHandler] = useState<any>()
  const [isShowingCert, setIsShowingCert] = useState<boolean>(false)
  const { state, setState, patchState } = useStore()
  const history = useHistory()

  useEffect(() => {
    if (isTimeShown && startTime && !endTime) {
      const interval = setInterval(() => {
        const diff = +new Date() - startTime
        setTimeSec(Math.floor(diff / 1000))
      }, 999)
      setIntervalHandler(interval)
      return () => {
        clearInterval(interval)
      }
    }
  }, [])

  useEffect(() => {
    if (isTimeShown && startTime && endTime && intervalHandler) {
      clearInterval(intervalHandler)
    }
  }, [endTime])

  useEffect(() => {
    setUsername(state.username)
    let [nextScore, nextErrors, nextSuccessRate] = [0, 0, 0]
    if (!customScore || !customErrors) {
      Object.keys(state.games).forEach((g: any) => {
        nextScore += state.games[g].score
        nextErrors += state.games[g].errors
      })
    }
    if (customScore !== undefined) {
      nextScore = customScore
    }
    if (customErrors !== undefined) {
      nextErrors = customErrors
    }
    setScore(nextScore)
    setErrors(nextErrors)
    nextSuccessRate = 100 - nextErrors / ((nextScore + nextErrors) / 100)
    setSuccessRate(isNaN(nextSuccessRate) ? 0 : nextSuccessRate)
  }, [state])

  const printCertificate = () => {
    setIsShowingCert(true)
    // setTimeout(() => setIsShowingCert(false), 10000)
    // return <BlankWindow children={<Certificate />} />
    // history.push('/diplom')
  }

  const resetUserProgress = () => {
    if (confirm('Smazat záznam o předchozích hrách pro aktuálního uživatele?')) {
      setState({
        username,
        score: 0,
        errors: 0,
        timeMs: 0,
        isWinter: false,
        isFirstRun: true,
        games: {},
      })
    }
  }

  const logout = () => {
    Storage.setBackup(state.username, state)
    history.push('/login')
  }

  const scoreCssVal = { '--value': `${score}` } as React.CSSProperties
  const errorsCssVal = { '--value': `${errors}` } as React.CSSProperties
  const timeCssVal = { '--value': `${timeSec}` } as React.CSSProperties

  const maxPoints = 80
  const gameProgress = score / (maxPoints / 100)

  const sumGameTimeSecs = state.timeMs / 1000

  const getPointsString = () => {
    return score === 1 ? 'bod' : score > 1 && score < 5 ? 'body' : 'bodů'
  }
  const getErrorsString = () => {
    return errors === 1 ? 'chyba' : errors > 1 && errors < 5 ? 'chyby' : 'chyb'
  }

  return (
    <div
      className="flex flex-col justify-start card glass absolute right-5 w-72 p-2 z-10"
      style={{ height: 'calc(100vh - 2.5rem)' }}
    >
      {isActionsShown && <div className="text-3xl font-bold mt-2 mb-2">{username}</div>}
      {isActionsShown && <hr />}
      <div className="text-xl font-bold mt-3 mb-1">
        {score} {getPointsString()} /{' '}
        <span className="text-red-700">
          {errors} {getErrorsString()}
        </span>
      </div>
      {isActionsShown && <div className="mt-2">úspěšnost {successRate.toFixed(0)}%</div>}
      {isActionsShown && <div className="mt-2">dokončeno {gameProgress.toFixed(0)}%</div>}
      {isActionsShown && (
        <button
          className="text-xl text-black btn btn-lg btn-block mb-5 mt-5 glass"
          // disabled={gameProgress < 1}
          onClick={() => {
            if (!isShowingCert) {
              printCertificate()
            } else {
              setIsShowingCert(false)
              setTimeout(() => printCertificate(), 500)
            }
          }}
        >
          Vytisknout diplom
        </button>
      )}
      {isShowingCert && <BlankWindow children={<Certificate />} />}
      {isActionsShown && <hr />}
      {isActionsShown && <div className="mt-5">aktivní kolo: {state.isWinter ? 2 : 1}</div>}
      {isActionsShown && <div className="text-3xl font-bold mt-2">{state.isWinter ? 'zima' : 'léto'}</div>}
      {isActionsShown && (
        <button
          className="text-xl text-black btn btn-lg btn-block mb-5 mt-5 glass"
          onClick={() => patchState({ isWinter: !state.isWinter })}
        >
          {state.isWinter ? 'zpět do 1. kola' : 'pokračovat do 2. kola'}
        </button>
      )}
      {/*{customText && customText.length > 0 && (*/}
      {/*  <div className="mt-10 border rounded-xl p-1">*/}
      {/*    {customText.map(m => <div className="mb-2">{m}</div>)}*/}
      {/*  </div>*/}
      {/*)}*/}
      {statusText && statusText.length > 0 && (
        <div className="mt-2 border rounded-xl p-1">
          {statusText.map(m => (
            <div className="mt-1 mb-1">{m}</div>
          ))}
        </div>
      )}
      {isActionsShown && (
        <div className="mt-auto">
          <div className="flex mt-5">
            <button className="btn text-black text-xl w-1/2 mr-1 glass" onClick={() => resetUserProgress()}>
              Resetovat
            </button>
            <button className="btn text-black text-xl w-1/2 ml-1 glass" onClick={() => logout()}>
              Odhlásit
            </button>
          </div>
          <img
            src={logoUhul}
            alt=""
            className="image-full w-full float-right rounded-xl mb-2 opacity-60 hover:opacity-75 cursor-pointer mt-2"
            onClick={() => window.open('//www.uhul.cz')}
          />
          <button className="text-xl text-black btn btn-block glass" onClick={() => history.push('/o-aplikaci')}>
            o aplikaci
          </button>
        </div>
      )}
      {!isActionsShown && (
        <div className="mt-auto">
          <button className="text-xl text-black btn btn-block glass z-50" onClick={() => history.push('/dashboard')}>
            zpět
          </button>
        </div>
      )}
    </div>
  )
}
